import React, { useEffect, useRef, useState } from "react";
import Line from "../main/Line";
import InfiniteScroll from "react-infinite-scroll-component";

let inMemoryCache = {
  renderedCount: 0,
  // scrollPosition: 0,
};

export const InfiniteScrollList = ({
  allItems,
  renderItem,
  itemsPerLoad,
  loadImages,
}) => {
  const [renderItems, setRenderItems] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const ITEMS_PER_LOAD = useRef(itemsPerLoad); // default fallback
  const isFirstLoad = useRef(true);

  useEffect(() => {
    const itemHeight = 330; // estimated height
    const screenItemCount = Math.ceil(window.innerHeight / itemHeight);
    ITEMS_PER_LOAD.current = Math.max(itemsPerLoad, screenItemCount);

    const cachedCount = inMemoryCache.renderedCount || 0;
    const initialCount = cachedCount > 0 ? cachedCount : ITEMS_PER_LOAD.current;
    const initialItems = allItems.slice(0, initialCount);
    setRenderItems(initialItems);

    if (initialItems.length >= allItems.length) {
      setHasMore(false);
    }

    // if (inMemoryCache.scrollPosition) {
    //   setTimeout(() => {
    //     window.scrollTo(0, inMemoryCache.scrollPosition);
    //   }, 0);
    // }

    isFirstLoad.current = false;
  }, [allItems, itemsPerLoad]);

  const fetchMoreData = async () => {
    const start = renderItems.length;
    const end = start + ITEMS_PER_LOAD.current;
    const nextItems = allItems.slice(start, end);

    loadImages(nextItems);
    if (isFirstLoad.current) {
      setRenderItems((prev) => [...prev, ...nextItems]);
    } else {
      // Remove artificial delay - render immediately
      setRenderItems((prev) => {
        const updatedItems = [...prev, ...nextItems];

        inMemoryCache.renderedCount = updatedItems.length;

        if (updatedItems.length >= allItems.length) {
          setHasMore(false);
        }

        return updatedItems;
      });
    }
  };


  // useEffect(() => {
  //   const handleScroll = () => {
  //     inMemoryCache.scrollPosition = window.scrollY;
  //   };

  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  return (
    <InfiniteScroll
      dataLength={renderItems.length}
      next={fetchMoreData}
      hasMore={hasMore}
      loader={
        <Line type="bottom-line" style={{ justifyContent: "center" }}>
          loading...
        </Line>
      }
      style={{ overflow: "visible" }}
    >
      {renderItems.map((item, index) => renderItem(item, index))}
    </InfiniteScroll>
  );
};
